module.exports = __webpack_public_path__ + "static/media/medimart-fb-cover.b2adcb61.jpg";